import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import PageHeader from '@/components/page/page-header.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'page-layout',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_ctx.$style.root)
            }, [
                _createVNode(PageHeader),
                _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$style.content)
                }, [
                    _renderSlot(_ctx.$slots, "default")
                ], 2)
            ], 2));
        };
    }
});
